import { Injectable } from "@angular/core";
import { FlightInput } from "../_models/flight-input.model";

@Injectable({
  "providedIn": "root",
})
export class SearchResultService {

  selectedFlights: FlightInput[] = [];

  setSelectedFlights (selectedFlights: FlightInput[], searchUUID: string) {
    this.selectedFlights = selectedFlights;
    localStorage.setItem(
      "selectedFlights",
      JSON.stringify({ "values": this.selectedFlights, searchUUID }),
    );
  }

  getSelectedFlights (): { values: FlightInput[]; searchUUID: string } {
    return JSON.parse(localStorage.getItem("selectedFlights"));
  }

  getSelectedQuoteType (): boolean {
    return JSON.parse(localStorage.getItem("quoteType"));
  }

  setSelectedQuoteType (selectedQuoteType: boolean) {
    localStorage.setItem("quoteType", JSON.stringify(selectedQuoteType));
  }

  getPreSelectFlightValue (): boolean {
    return JSON.parse(localStorage.getItem("preSelectFlight"));
  }

  setPreSelectFlightValue (value: boolean) {
    localStorage.setItem("preSelectFlight", JSON.stringify(value));
  }
}
